



















import Vue from 'vue';
import SearchBannerImageSkeleton from './skeletons/SearchBannerImageSkeleton.vue';
import SearchBannerContentSkeleton from './skeletons/SearchBannerContentSkeleton.vue';
import Loader from '../../../../../../frontend/components/Loader.vue';

export default Vue.extend({
  name: 'SearchBanner',
  components: {
    SearchBannerImageSkeleton,
    SearchBannerContentSkeleton,
    Loader,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    imageSrc: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
  },
  computed: {
    loading(): boolean {
      return this.$store.getters[`${this.storeNamespace}/isLoading`];
    },
    refetching(): boolean {
      return this.$store.getters[`${this.storeNamespace}/isRefetching`];
    },
  },
});
